import { formatCurrencyFromMicros, formatInteger, formatPlatform, formatRoas } from '../constants';
import { PlatformPillFilter } from './PlatformPillFilter';

export function TopAdsTable({
  ads = [],
  platforms = [],
  selectedPlatform = null,
  onSelectPlatform = () => {},
  isLoading = false,
  error = null,
}) {
  const platformLabel = selectedPlatform ? formatPlatform(selectedPlatform) : 'selected platform';

  return (
    <section className="rounded-2xl border border-mystic-500 bg-white p-5 shadow-sm" aria-label="Top ads leaderboard">
      <div className="flex items-center justify-between gap-4">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.14em] text-lynch-500">Top Ads</p>
          <h2 className="mt-2 text-lg font-semibold text-black-pearl-500">Highest spend by ad creative</h2>
        </div>
      </div>
      <div className="mt-4">
        <PlatformPillFilter
          ariaLabel="Filter top ads by platform"
          platforms={platforms}
          selectedPlatform={selectedPlatform}
          onSelectPlatform={onSelectPlatform}
        />
      </div>
      {isLoading ? (
        <p className="mt-6 text-sm text-lynch-500">Loading {platformLabel} ads...</p>
      ) : error ? (
        <p className="mt-6 text-sm text-red-700">We couldn&apos;t load ads for {platformLabel} right now.</p>
      ) : ads.length === 0 ? (
        <p className="mt-6 text-sm text-lynch-500">No ads have reported spend for the selected range yet.</p>
      ) : (
        <div className="mt-6 overflow-x-auto">
          <table className="min-w-full divide-y divide-mystic-500 text-left text-sm">
            <thead>
              <tr className="text-xs font-semibold uppercase tracking-[0.12em] text-lynch-500">
                <th className="pb-3 pr-4">Ad</th>
                <th className="pb-3 pr-4">Platform</th>
                <th className="pb-3 pr-4">Spend</th>
                <th className="pb-3 pr-4">ROAS</th>
                <th className="pb-3 pr-4">Clicks</th>
                <th className="pb-3">Impressions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-solitude-500">
              {ads.map((ad) => (
                <tr key={ad.id}>
                  <td className="py-3 pr-4 font-medium text-black-pearl-500">{ad.name}</td>
                  <td className="py-3 pr-4 text-lynch-500">{formatPlatform(ad.platform)}</td>
                  <td className="py-3 pr-4 text-black-pearl-500">{formatCurrencyFromMicros(ad.spendMicros)}</td>
                  <td className="py-3 pr-4 text-black-pearl-500">{formatRoas(ad.roas)}</td>
                  <td className="py-3 pr-4 text-black-pearl-500">{formatInteger(ad.clicks)}</td>
                  <td className="py-3 text-black-pearl-500">{formatInteger(ad.impressions)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
